import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import moment from 'moment';
import * as ajax from './ajax';
import store from '../reducers/storeRegistration';
import entityActionFactory from './factories/entityActionFactory';
import mapConstants from '../constants/mapConstants';
import tokenErrorActions from './tokenErrorActionCreators';
const entityActions = entityActionFactory('map', 'forms');
const setCurrentCabinet = currentCabinet => ({
  type: mapConstants.SET_CURRENT,
  currentCabinet
});
const setMapInitialized = cabinetIdentifier => ({
  type: mapConstants.SET_INITIALIZED,
  cabinetIdentifier
});
const serverIndex = (cabinet, indexQuery) => async dispatch => {
  let mapIndexQuery = null;
  const mapStore = store.getState().map;
  if (mapStore.currentCabinet !== cabinet) {
    dispatch(setCurrentCabinet(cabinet));
  }
  if (mapStore[cabinet]) {
    mapIndexQuery = mapStore[cabinet].indexQuery;
  }
  if (indexQuery.initialized && _.isEqual(indexQuery, mapIndexQuery) && moment().isBefore(moment.unix(indexQuery.expiration), 'minute')) {
    return null;
  }
  await dispatch(entityActions.serverIndex(indexQuery));
  return null;
};

/**
 * Set the map type (standard, satellite, or hybrid).
 */
const setMapType = selectedMapType => ({
  type: mapConstants.SET_TYPE,
  payload: selectedMapType
});
const setMapView = (cabinetIdentifier, bbox, zoom) => ({
  type: mapConstants.SET_VIEW,
  payload: {
    cabinetIdentifier,
    bbox,
    zoom
  }
});
const getClusterItems = params => async dispatch => {
  try {
    dispatch({
      type: mapConstants.CLUSTER_ITEMS_REQUEST
    });
    const bbox = params.bbox,
      clusterId = params.clusterId,
      filters = params.filters,
      itemId = params.itemId,
      _params$mapView = params.mapView,
      mapView = _params$mapView === void 0 ? true : _params$mapView,
      zoom = params.zoom;
    let url = "/forms?bbox=".concat(bbox, "&zoom=").concat(zoom, "&mapView=").concat(mapView);
    if (clusterId) {
      url += "&clusterId=".concat(clusterId);
    }
    if (itemId) {
      url += "&itemId=".concat(itemId);
    }
    Object.entries(filters).forEach(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (key === 'cabinetIdentifier') {
        url += "&filters[".concat(key, "]=").concat(encodeURIComponent(value));
      } else if (Array.isArray(value)) {
        if (value.length > 0 && Array.isArray(value[0])) {
          value.forEach((outer, i) => {
            outer.forEach((inner, j) => {
              url += "&filters[".concat(key, "][").concat(i, "][").concat(j, "]=").concat(encodeURIComponent(inner));
            });
          });
        } else {
          value.forEach(val => {
            url += "&filters[".concat(key, "][]=").concat(encodeURIComponent(val));
          });
        }
      }
    });
    const response = await ajax.get(url);
    return dispatch({
      type: mapConstants.CLUSTER_ITEMS_SUCCESS,
      payload: response.data
    });
  } catch (err) {
    return dispatch(tokenErrorActions.handleError(err, 'form', () => ({
      type: mapConstants.CLUSTER_ITEMS_FAILURE,
      error: err
    }), getClusterItems.bind(null, params)));
  }
};
const mapActions = _objectSpread(_objectSpread({}, entityActions), {}, {
  serverIndex,
  getClusterItems,
  setMapInitialized,
  setMapType,
  setMapView,
  setCurrentCabinet
});
export default mapActions;